import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import MasterLayout from '../../components/AppLayout/MasterLayout';
import { spaces } from '../../assets/styles/themes/tokens';
import { useSelector } from 'react-redux';
import { selectIsOnboardingCompleted, selectUser } from '../../reducers/user.selectors';
import DashboardPageHeader from '../../components/DashboardPageHeader';
import useFetchDashboardSubjectsProducts from './hooks/useFetchDashboardSubjects';
import CoursesCarousel from '../../components/Dashboard/CoursesCarousel';
import SubjectCarousel from '../../components/Dashboard/SubjectCarousel';
import StudyflixCarousel from '../../components/Dashboard/StudyflixCarousel';
import PinnedDocumentsCarousel from '../../components/Dashboard/PinnedDocumentsCarousel/PinnedDocumentsCarousel';
import MukiActionCarousel from '../../components/Dashboard/MukiActionCarousel';
import { palette } from '../../assets/styles/themes/tokens';
import useRouter from '../../utils/useRouter';
import { routes } from '../../constants';
import config from 'config';
import { useAmplitudeExperiment } from '../../utils/ampli';
import useShouldShowAIAssistant from '../../utils/useShouldShowAIAssistant';
const NewDashboardPage: React.FC = () => {
  const { router } = useRouter();
  const user = useSelector(selectUser);
  const subjects = useFetchDashboardSubjectsProducts();
  const isOnboardingCompleted = useSelector(selectIsOnboardingCompleted);
  const { isReady, variant } = useAmplitudeExperiment(user, config.amplitudeExperiments.dashboard);
  const shouldShowAIAssistant = useShouldShowAIAssistant();
  // A treatment user who can't use Muki would get a blank new dashboard (the carousel
  // self-gates to null), so keep the legacy carousels unless they're Muki-eligible too.
  const showNewDashboard = isReady && variant === 'treatment' && shouldShowAIAssistant;

  useEffect(() => {
    if (!isOnboardingCompleted) {
      router.replace(`/${routes.onboardingPage.root}?step=roles`);
    }
  }, [isOnboardingCompleted]);

  if (!user) return null;
  const hasSubjects = subjects.userSubjects.length !== 0;
  const initialSubjects = subjects.userSubjects.slice(0, 2);
  const remainingSubjects = subjects.userSubjects.slice(2);

  return (
    <MasterLayout forceNewNavigation>
      <Box
        sx={{
          backgroundColor: palette.background.paperElevation1,
          minHeight: '100vh'
        }}
      >
        <Box sx={{
          paddingTop: spaces.sm,
          paddingLeft: spaces.md,
          paddingBottom: spaces.xxxxl,
          display: 'flex',
          flexDirection: 'column',
          gap: spaces.lg,
        }}>
          <DashboardPageHeader firstName={user?.firstName} />
          {showNewDashboard ? (
            <MukiActionCarousel />
          ) : (
            <>
              {
                hasSubjects && initialSubjects.map(subject => <SubjectCarousel key={subject.id} subject={subject} />)
              }
              <StudyflixCarousel />
              {
                remainingSubjects.length ?
                  remainingSubjects.map(subject => <SubjectCarousel key={subject.id} subject={subject} />)
                  : undefined
              }
              { subjects.defaultSubject && <SubjectCarousel subject={subjects.defaultSubject} /> }
              <PinnedDocumentsCarousel />
              <CoursesCarousel />
            </>
          )}
        </Box>
      </Box>
    </MasterLayout>
  );
};

export default NewDashboardPage;

